import { css } from '@emotion/react';
import * as React from 'react';
import { useMediaLayout } from 'use-media';
import { OwnerCompanyForm } from '../../components/OwnerCompanyForm';
import { OwnerList } from '../../components/OwnerList';
import { EditItem } from '../../components/OwnerList/EditItem';
import { OwnerPersonForm } from '../../components/OwnerPersonForm';
import { OwnershipSummary } from '../../components/OwnershipSummary';
import { BoxHeading } from '../../components/box';
import { Button } from '../../components/buttons';
import { PlusIcon } from '../../icons';

type Mode = 'list' | 'adding-person' | 'adding-company';

interface State {
  mode: Mode;
}

export class MultiOwnershipSection extends React.Component<unknown, State> {
  constructor(props) {
    super(props);
    this.state = { mode: 'list' };
  }

  modeSetter = (mode: Mode) => {
    return () => {
      this.setState({ mode });
    };
  };

  render() {
    const { mode } = this.state;
    return (
      <>
        <OwnerList />
        {mode === 'adding-company' && (
          <EditItem data-testid="RoleSection">
            <BoxHeading>Legg til selskap</BoxHeading>
            <OwnerCompanyForm onDone={this.modeSetter('list')} />
          </EditItem>
        )}
        {mode === 'adding-person' && (
          <EditItem data-testid="RoleSection">
            <BoxHeading>Legg til person</BoxHeading>
            <OwnerPersonForm onDone={this.modeSetter('list')} editType="new" />
          </EditItem>
        )}
        {mode === 'list' && (
          <>
            <OwnershipSummary />
            <Button
              css={css`
                margin-right: 1em;
              `}
              level="secondary"
              onClick={this.modeSetter('adding-company')}
              icon={<Icon />}
            >
              Legg til selskap
            </Button>
            <Button
              level="secondary"
              onClick={this.modeSetter('adding-person')}
              icon={<Icon />}
            >
              Legg til person
            </Button>
          </>
        )}
      </>
    );
  }
}

function Icon() {
  const isWide = useMediaLayout('(min-width: 400px)');
  return isWide ? (
    <PlusIcon
      css={css`
        margin-top: -2px;
      `}
    />
  ) : undefined;
}
